import { State } from '../../types';

export const ohio: State = {
  name: 'Ohio',
  abbreviation: 'OH',
  terms: [
    {
      word: 'Bellefontaine',
      phonetic: 'behl-FOWN-tuhn',
      // audioUrl: '/audio/bellefontaine.mp3',
      description: 'A city in Logan County, pronounced with emphasis on the second syllable, rhyming with "fountain."'
    },
    {
      word: 'Bucyrus',
      phonetic: 'bew-SIGH-russ',
      // audioUrl: '/audio/bucyrus.mp3',
      description: 'A city in Crawford County, often mispronounced due to its unique spelling.'
    },
    {
      word: 'Celina',
      phonetic: 'suh-LYE-nuh',
      // audioUrl: '/audio/celina.mp3',
      description: 'A city in Mercer County, pronounced with a long "i" sound in the second syllable.'
    },
    {
      word: 'Chillicothe',
      phonetic: 'chill-uh-KAW-thee',
      // audioUrl: '/audio/chillicothe.mp3',
      description: 'A city in Ross County, with a name derived from a Shawnee word meaning "principal town."'
    },
    {
      word: 'Conneaut',
      phonetic: 'KAW-nee-awt',
      // audioUrl: '/audio/conneaut.mp3',
      description: 'A city in Ashtabula County, located along Lake Erie, with a name of Native American origin.'
    },
    {
      word: 'Cuyahoga',
      phonetic: 'kye-uh-HO-guh',
      // audioUrl: '/audio/cuyahoga.mp3',
      description: 'A county and river in Ohio, with a name derived from a Native American word meaning "crooked river."'
    },
    {
      word: 'Gallipolis',
      phonetic: 'gal-ih-POH-liss',
      // audioUrl: '/audio/gallipolis.mp3',
      description: 'A city in Gallia County, founded by French settlers, with a name meaning "City of the Gauls."'
    },
    {
      word: 'Gnadenhutten',
      phonetic: 'guh-NAY-dn-hoo-tn',
      // audioUrl: '/audio/gnadenhutten.mp3',
      description: 'A village in Tuscarawas County, with a name meaning "Tents of Grace" in German.'
    },
    {
      word: 'Lancaster',
      phonetic: 'LANG-kast-er',
      // audioUrl: '/audio/lancaster.mp3',
      description: 'A city in Fairfield County, pronounced differently from its English namesake.'
    },
    {
      word: 'Lima',
      phonetic: 'LYE-muh',
      // audioUrl: '/audio/lima.mp3',
      description: 'A city in Allen County, pronounced differently from the capital of Peru.'
    },
    {
      word: 'Louisville',
      phonetic: 'LEW-iss-vil',
      // audioUrl: '/audio/louisville.mp3',
      description: 'A city in Stark County, pronounced with emphasis on the first syllable.'
    },
    {
      word: 'Mantua',
      phonetic: 'MAN-uh-way',
      // audioUrl: '/audio/mantua.mp3',
      description: 'A village in Portage County, pronounced with three syllables.'
    },
    {
      word: 'Massillon',
      phonetic: 'MASS-ih-luhn',
      // audioUrl: '/audio/massillon.mp3',
      description: 'A city in Stark County, with a name of French origin.'
    },
    {
      word: 'Medina',
      phonetic: 'meh-DYE-nuh',
      // audioUrl: '/audio/medina.mp3',
      description: 'A city in Medina County, pronounced differently from its Middle Eastern namesake.'
    },
    {
      word: 'Milan',
      phonetic: 'MY-luhn',
      // audioUrl: '/audio/milan.mp3',
      description: 'A village in Erie and Huron counties, pronounced differently from the Italian city.'
    },
    {
      word: 'Piqua',
      phonetic: 'PIK-wah',
      // audioUrl: '/audio/piqua.mp3',
      description: 'A city in Miami County, with a name derived from a Shawnee word.'
    },
    {
      word: 'Scioto',
      phonetic: 'sigh-OH-tuh',
      // audioUrl: '/audio/scioto.mp3',
      description: 'A river and county in Ohio, with a name derived from a Native American word meaning "deer."'
    },
    {
      word: 'Versailles',
      phonetic: 'ver-SALES',
      // audioUrl: '/audio/versailles.mp3',
      description: 'A village in Darke County, pronounced differently from the French city.'
    },
    {
      word: 'Wapakoneta',
      phonetic: 'wah-pah-kah-NET-uh',
      // audioUrl: '/audio/wapakoneta.mp3',
      description: 'A city in Auglaize County, known as the birthplace of astronaut Neil Armstrong.'
    },
    {
      word: 'Wooster',
      phonetic: 'WUSS-ter',
      // audioUrl: '/audio/wooster.mp3',
      description: 'A city in Wayne County, pronounced with a silent "o."'
    },
    {
      word: 'Xenia',
      phonetic: 'ZEEN-yuh',
      // audioUrl: '/audio/xenia.mp3',
      description: 'A city in Greene County, with a name meaning "hospitality" in Greek.'
    }
  ]
};